/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Node } from '../models/Node';

/**
 * Interface used when performing validation - this gathers up any validation problem found
 * so that they can be reported in some sensible way.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IValidationProblemReporter {
    /**
     * Called to report a validation rule violation.
     * @param {ValidationRuleMetaData} rule
     * @param {Node} node
     * @param {string} property
     * @param {string} message
     */
    report(rule : ValidationRuleMetaData, node : Node, property : string, message : string);
}



import { ValidationRuleMetaData } from './ValidationRuleMetaData';

